import brotregal from 'assets/png/food-store/brotregal.png';
import brotregalActive from 'assets/png/food-store/brotregal_on.png';
import fenster from 'assets/png/food-store/fenster.png';
import fensterActive from 'assets/png/food-store/fenster_on.png';
import flyer from 'assets/png/food-store/plakat_aktion.png';
import kasse from 'assets/png/food-store/kasse.png';
import kasseActive from 'assets/png/food-store/kasse_on.png';
import klimaanlage from 'assets/png/food-store/klimaanlage.png';
import klimaanlageActive from 'assets/png/food-store/klimaanlage_on.png';
import kuehlhaus from 'assets/png/food-store/kuehlhaus.png';
import kuehlhausActive from 'assets/png/food-store/kuehlhaus_on.png';
import kuehlregal from 'assets/png/food-store/kuehlregal.png';
import kuehlregalActive from 'assets/png/food-store/kuehlregal_on.png';
import lichterLinks from 'assets/png/food-store/lichter_links.png';
import lichterLinksActive from 'assets/png/food-store/lichter_links_on.png';
import lichterOben from 'assets/png/food-store/lichter_oben.png';
import lichterObenActive from 'assets/png/food-store/lichter_oben_on.png';
import lichterRechts from 'assets/png/food-store/lichter_rechts.png';
import lichterRechtsActive from 'assets/png/food-store/lichter_rechts_on.png';
import stand from 'assets/png/food-store/objekt_1.png';
import tiefkuehlkost from 'assets/png/food-store/tiefkuehlkost.png';
import tiefkuehlkostActive from 'assets/png/food-store/tiefkuehlkost_on.png';

import background from 'assets/png/food-store/Food_BG.png';


export default {
  exitLabel: 'Laden verlassen',
  background: {
    src: background,
  },
  items: {
    kuehlhaus: {
      baseSrc: kuehlhaus,
      activeSrc: kuehlhausActive,
      height: 41.8,
      top: 38.1,
      left: 7.1,
      level: 0,
      infopanel: {
        content: {
          title: 'Kühlräume',
          description: 'Am meisten Energie geht in Kühlräumen beim Öffnen von Türen verloren. Stehen die Türen Ihrer Kühlräume unnötig offen oder haben Sie sogar Kühlstellen ganz ohne Türen, sollten Sie schleunigst Maßnahmen ergreifen. Und nicht nur dann: Besteht Eisbildung an der Decke, Böden und Wänden, müssen Sie in Aktion treten.',
          link: {
            title: 'Jetzt handeln!',
            url: 'https://www.hde-klimaschutzoffensive.de/de/kuehlhaeuser_und_kuehlraeume?pk_campaign=virtuelle-marktstrasse&pk_source=frischemarkt&pk_content=kuehlhaeuser_und_kuehlraeume',
          },
        },
        overlay: {
          x: 'right',
          y: 'bottom',
        },
        button: {
          top: -3,
          left: 90,
        },
      },
    },
    lichterLinks: {
      baseSrc: lichterLinks,
      activeSrc: lichterLinksActive,
      height: 2.5,
      top: 34,
      left: 22,
      level: 0,
      infopanel: {
        content: {
          title: 'LED-Beleuchtung',
          description: 'Die Umstellung von konventionellen Leuchtmitteln auf LED-Lampen ist schon jetzt eine der wichtigsten Energieeffizienzmaßnahmen im Einzelhandel. Je nach bisher eingesetzter Technik können Sie damit bis zu 50 Prozent Energie einsparen. Und nicht nur das! LED lässt durch tolle Farben auch Ihre Waren und Produkte im besten Licht erscheinen.',
          link: {
            title: 'Jetzt handeln!',
            url: 'https://www.hde-klimaschutzoffensive.de/de/austausch_beleuchtung?pk_campaign=virtuelle-marktstrasse&pk_source=frischemarkt&pk_content=austausch_beleuchtung',
          },
        },
        overlay: {
          x: 'right',
          y: 'bottom',
        },
        button: {
          top: 65,
          left: -12,
        },
      },
    },
    lichterOben: {
      baseSrc: lichterOben,
      activeSrc: lichterObenActive,
      height: 15.1,
      top: 1.3,
      left: 27.8,
      level: 0,
      infopanel: {
        content: {
          title: 'Lichtsteuerung',
          description: 'Sie sollen besonders gut aussehen und im besten Licht erscheinen: Ihre Waren und Sonderaktionen auf den Verkaufsflächen oder im Schaufenster. Mit einer zentralen Lichtsteuerung können Sie je nach Gebäude fast die Hälfte der Stromkosten einsparen. Erfahren Sie jetzt mehr über Zeitsteuerungen, Präsenzerfassung und Tageslichtnutzung.',
          link: {
            title: 'Jetzt handeln!',
            url: 'https://www.hde-klimaschutzoffensive.de/de/lichtsteuerung?pk_campaign=virtuelle-marktstrasse&pk_source=frischemarkt&pk_content=lichtsteuerung',
          },
        },
        overlay: {
          x: 'left',
          y: 'bottom',
        },
        button: {
          top: 92.5,
          left: 55,
        },
      },
    },
    klimaanlage: {
      baseSrc: klimaanlage,
      activeSrc: klimaanlageActive,
      height: 3.8,
      top: 9.4,
      left: 65.6,
      level: 0,
      infopanel: {
        content: {
          title: 'Raumluft',
          description: 'Als Einzelhändler wissen Sie genau wie wichtig eine optimale Temperierung und Luftqualität in den Verkaufsräumen ist. Zum Beispiel im Winter, wenn Kunden ihre Jacken und Mäntel beim Einkaufen anlassen, das Personal im Geschäft jedoch eine wohltemperierte Arbeitsumgebung benötigt. Oftmals ist die richtige Einstellung der Raumluft kein Kinderspiel und erfordert technisches Know-how. Hier erfahren Sie alles, was Sie dazu wissen müssen.',
          link: {
            title: 'Jetzt handeln!',
            url: 'https://www.hde-klimaschutzoffensive.de/de/raumluft?pk_campaign=virtuelle-marktstrasse&pk_source=frischemarkt&pk_content=raumluft',
          },
        },
        overlay: {
          x: 'left',
          y: 'bottom',
        },
        button: {
          top: 59,
          left: -4,
        },
      },
    },
    fenster: {
      baseSrc: fenster,
      activeSrc: fensterActive,
      height: 18.5,
      top: 11.3,
      left: 72.4,
      level: 0,
      infopanel: {
        content: {
          title: 'Tageslichtnutzung',
          description: 'Lassen Sie die Sonne rein! Holen Sie sich hier Tipps, wie Sie Tageslicht am besten für sich nutzen können, damit Sie den Lichtschalter nur noch anknipsen müssen, wenn dies wirklich nötig ist. Tageslicht schafft eine angenehme Atmosphäre für Mitarbeiter und Kunden. Erfahren Sie hier wie Sie die kostenlose Lichtquelle optimal nutzen und mehr Helligkeit in Ihre Räume bringen.',
          link: {
            title: 'Jetzt handeln!',
            url: 'https://www.hde-klimaschutzoffensive.de/de/tageslichtnutzung?pk_campaign=virtuelle-marktstrasse&pk_source=frischemarkt&pk_content=tageslichtnutzung',
          },
        },
        overlay: {
          x: 'left',
          y: 'bottom',
        },
        button: {
          top: 45.5,
          left: -3.5,
        },
      },
    },
    lichterRechts: {
      baseSrc: lichterRechts,
      activeSrc: lichterRechtsActive,
      height: 2.9,
      top: 29.4,
      left: 72.3,
      level: 0,
      infopanel: {
        content: {
          title: 'LED-Beleuchtung',
          description: 'Die Umstellung von konventionellen Leuchtmitteln auf LED-Lampen ist schon jetzt eine der wichtigsten Energieeffizienzmaßnahmen im Einzelhandel. Je nach bisher eingesetzter Technik können Sie damit bis zu 50 Prozent Energie einsparen. Und nicht nur das! LED lässt durch tolle Farben auch Ihre Waren und Produkte im besten Licht erscheinen.',
          link: {
            title: 'Jetzt handeln!',
            url: 'https://www.hde-klimaschutzoffensive.de/de/austausch_beleuchtung?pk_campaign=virtuelle-marktstrasse&pk_source=frischemarkt&pk_content=austausch_beleuchtung',
          },
        },
        overlay: {
          x: 'left',
          y: 'bottom',
        },
        button: {
          top: 63.7,
          left: 93.5,
        },
      },
    },
    brotregal: {
      baseSrc: brotregal,
      activeSrc: brotregalActive,
      height: 24.8,
      top: 26.6,
      left: 53.6,
      level: 1,
      infopanel: {
        content: {
          title: 'Energiespartipp: Verbräuche erfassen',
          description: 'Manchmal reichen schon kleine Handgriffe, um Energie einzusparen. Bei größeren Investitionen in Energieeffizienz zögern viele Einzelhändler mit der Umsetzung, obwohl sich diese oft innerhalb kurzer Zeit amortisieren. Kommt Ihnen das bekannt vor? Wagen Sie den ersten Schritt und führen Sie ein systematisches Energiemanagement ein. Mit der Analyse Ihrer Verbräuche und Kosten können Sie dann passende Energiesparmaßnahmen ableiten.',
          link: {
            title: 'Jetzt handeln!',
            url: 'https://www.hde-klimaschutzoffensive.de/de/technische-sofortmassnahmen?pk_campaign=virtuelle-marktstrasse&pk_source=frischemarkt&pk_content=technische-sofortmassnahmen',
          },
        },
        overlay: {
          x: 'left',
          y: 'bottom',
        },
        button: {
          top: -5,
          left: -4,
        },
      },
    },
    kuehlregal: {
      baseSrc: kuehlregal,
      activeSrc: kuehlregalActive,
      height: 34,
      top: 33.1,
      left: 36.7,
      level: 2,
      infopanel: {
        content: {
          title: 'Kühlmöbel',
          description: 'Ihre Kühlmöbel sind schon etwas in die Jahre gekommen und verbrauchen zu viel Strom? Es muss nicht immer gleich ein Neukauf sein – oft reichen schon die richtige Pflege und ein paar Maßnahmen hier und da, um den Energiebedarf Ihrer Kühlmöbel deutlich zu senken. Denn richtig Kühlen ist eigentlich einfach, man muss nur wissen wie. ',
          link: {
            title: 'Jetzt handeln!',
            url: 'https://www.hde-klimaschutzoffensive.de/de/steckerfertige_kuehlmoebel?pk_campaign=virtuelle-marktstrasse&pk_source=frischemarkt&pk_content=steckerfertige_kuehlmoebel',
          },
        },
        overlay: {
          x: 'left',
          y: 'bottom',
        },
        button: {
          top: -3,
          left: -4.5,
        },
      },
    },
    tiefkuehlkost: {
      baseSrc: tiefkuehlkost,
      activeSrc: tiefkuehlkostActive,
      height: 24,
      top: 60.1,
      left: 29.6,
      level: 3,
      infopanel: {
        content: {
          title: 'Wärmerückgewinnung',
          description: 'Knapp die Hälfte der Stromkosten im Lebensmitteleinzelhandel fallen bei der Kälteerzeugung und Klimatisierung an – sie sind die größten Stromverbraucher im Food-Handel. Es gibt eine ganze Reihe von Möglichkeiten, den Energieverbrauch Ihrer Kühlmöbel zu senken oder deren Abwärme zu nutzen. Finden Sie heraus wie und klicken Sie sich durch unser Informationsangebot.',
          link: {
            title: 'Jetzt handeln!',
            url: 'https://www.hde-klimaschutzoffensive.de/de/verbundkaelteanlagen_waermerueckgewinnung?pk_campaign=virtuelle-marktstrasse&pk_source=frischemarkt&pk_content=verbundkaelteanlagen_waermerueckgewinnung',
          },
        },
        overlay: {
          x: 'left',
          y: 'top',
        },
        button: {
          top: -6,
          left: 5,
        },
      },
    },
    stand: {
      baseSrc: stand,
      height: 21,
      top: 47.1,
      left: 61.2,
      level: 2,
      ignoreEvents: true,
    },
    kasse: {
      baseSrc: kasse,
      activeSrc: kasseActive,
      height: 24.9,
      top: 65.3,
      left: 62.7,
      level: 4,
      infopanel: {
        content: {
          title: 'Energiespartipp: Energietarife prüfen',
          description: 'Jahrelang bei ein- und demselben Energieanbieter zu bleiben mag zwar bequem sein, wirtschaftlich sinnvoll ist das aber nicht immer. Checken Sie mindestens einmal jährlich die Verträge mit Ihren Energiezulieferern, um sich dauerhaft günstige Preise für Strom, Gas, Öl und Co. zu sichern.',
          link: {
            title: 'Jetzt handeln!',
            url: 'https://www.hde-klimaschutzoffensive.de/de/organisatorische-sofortmassnahmen?pk_campaign=virtuelle-marktstrasse&pk_source=frischemarkt&pk_content=organisatorische-sofortmassnahmen',
          },
        },
        overlay: {
          x: 'left',
          y: 'top',
        },
        button: {
          top: 10.2,
          left: -2.3,
        },
      },
    },
    flyer: {
      baseSrc: flyer,
      activeSrc: flyer,
      height: 11.5,
      top: 72.7,
      left: 84.9,
      level: 4,
      infopanel: {
        content: {
          title: 'Plastikmüll vermeiden',
          description: 'Energiesparen ist nur ein Baustein beim Klimaschutz. Deshalb setzt sich die Klimaschutzoffensive auch für einen nachhaltigen Umgang mit Plastik ein. Wollen Sie Plastiktüten reduzieren oder ganz auf sie verzichten? Viele Einzelhändler tun dies bereits. Machen Sie mit: Wir zeigen Ihnen wie und versorgen Sie mit kostenlosen Flyern, Postern und Infomaterialien.',
          link: {
            title: 'Jetzt handeln!',
            url: 'https://www.hde-klimaschutzoffensive.de/de/Kunststofftragetaschen?pk_campaign=virtuelle-marktstrasse&pk_source=frischemarkt&pk_content=kunststofftragetaschen',
          },
        },
        overlay: {
          x: 'left',
          y: 'top',
        },
        button: {
          top: -10.2,
          left: -10.3,
        },
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/config/FoodStoreConfig.js